import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || '';

const REASONS = [
  'Too expensive',
  "Didn't need it anymore",
  'Found a better alternative',
  'Too difficult to use',
  'Missing features I needed',
  'Caused issues with my store',
];

const styles = {
  body: {
    margin: 0,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    background: '#f6f6f7',
    color: '#1a1a1a',
    minHeight: '100vh',
  },
  container: {
    maxWidth: 560,
    margin: '60px auto',
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    padding: 40,
  },
  h1: { fontSize: 22, marginBottom: 8, marginTop: 0 },
  subtitle: { color: '#6d7175', marginBottom: 28, marginTop: 0 },
  reason: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 0',
    borderBottom: '1px solid #f1f1f1',
    cursor: 'pointer',
  },
  reasonLast: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 0',
    cursor: 'pointer',
  },
  checkbox: { width: 18, height: 18, accentColor: '#5c6ac4', cursor: 'pointer' },
  label: { cursor: 'pointer', fontSize: 15, margin: 0 },
  textarea: {
    width: '100%',
    height: 100,
    marginTop: 20,
    padding: 12,
    border: '1px solid #ddd',
    borderRadius: 8,
    fontFamily: 'inherit',
    fontSize: 14,
    resize: 'vertical',
    boxSizing: 'border-box',
    outline: 'none',
  },
  btn: {
    display: 'block',
    width: '100%',
    padding: 14,
    marginTop: 24,
    background: '#5c6ac4',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
  },
  btnDisabled: {
    display: 'block',
    width: '100%',
    padding: 14,
    marginTop: 24,
    background: '#b4b9d6',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'not-allowed',
  },
  success: { textAlign: 'center', padding: '40px 0' },
  successH2: { color: '#5c6ac4', marginBottom: 12, marginTop: 0 },
  successNote: { marginTop: 16, color: '#6d7175' },
};

function Feedback() {
  const [searchParams] = useSearchParams();
  const shop = searchParams.get('shop') || '';

  const [selected, setSelected] = useState([]);
  const [comments, setComments] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const toggleReason = (reason) => {
    setSelected((prev) =>
      prev.includes(reason) ? prev.filter((r) => r !== reason) : [...prev, reason]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await fetch(`${API_BASE}/api/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ shop, reasons: selected, comments }),
      });
    } catch (_) {
      // Show success regardless - don't block the user on a network error
    }
    setDone(true);
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        {done ? (
          <div style={styles.success}>
            <h2 style={styles.successH2}>Thank you for your feedback!</h2>
            <p>We appreciate you taking the time to help us improve.</p>
            <p style={styles.successNote}>
              Remember, your data is kept for 2 days. Reinstall anytime to pick up where you left off.
            </p>
          </div>
        ) : (
          <>
            <h1 style={styles.h1}>We're sorry to see you go</h1>
            <p style={styles.subtitle}>Your feedback helps us improve. What made you uninstall?</p>
            <form onSubmit={handleSubmit}>
              {REASONS.map((reason, i) => (
                <div
                  key={reason}
                  style={i === REASONS.length - 1 ? styles.reasonLast : styles.reason}
                >
                  <input
                    type="checkbox"
                    id={`r${i}`}
                    style={styles.checkbox}
                    checked={selected.includes(reason)}
                    onChange={() => toggleReason(reason)}
                  />
                  <label htmlFor={`r${i}`} style={styles.label}>{reason}</label>
                </div>
              ))}
              <textarea
                style={styles.textarea}
                placeholder="Any additional comments? (optional)"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
              />
              <button
                type="submit"
                disabled={submitting}
                style={submitting ? styles.btnDisabled : styles.btn}
              >
                {submitting ? 'Submitting...' : 'Submit Feedback'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default Feedback;
